import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { AppDispatch } from 'redux/store';
import { branchesWorkingTime } from 'global/Models/omOrderModel';
import { setOrderBranchesWorkingTime } from 'redux/reducer/ParcelOrder/parcelOrderReducer';

export const getBranchesWorkingTimes = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.branchesWorkingTimesForOrder)
    .then((res: IBackendSearchGeneric<branchesWorkingTime>) => {
      res.isSuccess && dispatch(setOrderBranchesWorkingTime(res.data));
    })
    .catch(() => {});
};
